export default __webpack_public_path__ + "static/2381-de8818729882e5277d0a7fba8a8b32f1.gif";